<template>
  <div :class="className">
    <div class="expanded-panel bg-white shadow mt-1 p-2 rounded">
      <div class="ly-row ly-end-center mt-half">
        <lp-icon name="close" class="cursor-pointer" @click="emit('onClose')" />
      </div>
      <slot name="sections"></slot>
      <slot name="actions"></slot>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'lp-expandable-panel',
}
</script>
<script lang="ts" setup>
withDefaults(
  defineProps<{
    className: string
  }>(),
  {
    className: 'w-40',
  },
)

const emit = defineEmits<{
  (event: 'onClose'): void
}>()
</script>
<style scoped>
.expanded-row {
  position: relative;
}
.expanded-row i {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
}

.mt-25 {
  margin-top: 2.5rem !important;
}

.absolute {
  position: absolute;
}
</style>
